import {Controller} from '@hotwired/stimulus';
import Axios from "../axios";

export default class extends Controller {

    static get targets() {
        return ['form', 'results', 'pagination'];
    }

    connect() {
        this.filters = {};
        this.timeout = undefined;
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
    }

    formTargetConnected() {
        this.element.querySelector('[name="s"]').addEventListener('input', () => {
            delete this.filters['page'];
            this.search();
        });
    }

    async search() {
        this.element.classList.add('loading');
        const form = this.targets.find('form');
        const data = new URLSearchParams(new FormData(form)).toString();
        const filters = new URLSearchParams(this.filters).toString();
        let url =`${theme.rest_route}search?rest_language=${this.currentLanguageCode}&${data}`;
        if (filters) {
            url += `&${filters}`;
        }

        if (this.timeout !== undefined) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(async () => {
            let response = null;
            try {
                response = await Axios.get(url);
                response = response.data;
                this.clearResults();
                this.targets.find('results').innerHTML = response.results_header_html;
                response.results_html.forEach((result) => {
                    this.insertResult(result);
                });
            } catch (error) {}

            this.element.classList.remove('loading');
        }, 300);
    }

    clearResults() {
        this.targets.find('results').innerHTML = '';
    }

    insertResult(data) {
        let html = '';
        if (data['url']) {
            if (data['image']) {
                html = `<a class="single-result-item" href="${data['url']}"><img src="${data['image']}" alt=""/>${data['title']}</a>`;
            } else {
                html = `<a class="single-result-item" href="${data['url']}">${data['title']}</a>`;
            }
        } else {
            html = `${data['title']}`;
        }
        this.targets.find('results').insertAdjacentHTML('beforeend', `${html}`);
    }
}
